import axios from "axios";
import { addToken } from "../APIKit";
import { API_URL } from "../constants";

import APIKit from "../APIKit";

function login(payload) {

  return new Promise((resolve, reject) => {

    APIKit.post("user_login", payload)
      .then(async (response) => {
        try {
          
          resolve(response.data);
        } catch (e) {
          reject(e);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}
function register(payload) {

  return new Promise((resolve, reject) => {

    APIKit.post("/user_register", payload)
      .then(async (response) => {
        try {


          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}
function socialLogin(payload) {

  return new Promise((resolve, reject) => {

    APIKit.post("/social_login", payload)
      .then(async (response) => {

        try {
     
        

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}
function socialRegister(payload) {
  return new Promise(async (resolve, reject) => {
    try {
    } catch (e) {
    }
    APIKit.post("/social_register", payload)
      .then(async (response) => {
        try {
 

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function mailVerification(payload) {

  return new Promise((resolve, reject) => {

    APIKit.post("/verify_email", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function phoneVerification(payload) {

  return new Promise((resolve, reject) => {

    APIKit.post("/verify_mobile", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function resendMailOTP(payload) {

  return new Promise((resolve, reject) => {

    APIKit.post("/send_otp_email", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function resendPhoneOTP(payload) {

  return new Promise((resolve, reject) => {

    APIKit.post("/send_otp_mobile", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function forgotPassword(payload) {

  return new Promise((resolve, reject) => {

    APIKit.post("/forgotPassword", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

async function logout(getState) {
  return new Promise((resolve, reject) => {
    const currentState = getState();
    const { token } = currentState.auth;
    axios
      .get(`${API_URL}/logout`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      .then(async (response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}

export const userService = {
  login,
  logout,
  register,
  mailVerification,
  phoneVerification,
  resendMailOTP,
  resendPhoneOTP,
  forgotPassword,
  socialRegister,
  socialLogin,
};
